import React from 'react'
import cx from 'classnames'

import { DIRECTIONS } from './constants'
import { spinnerBarPropTypes as propTypes } from './types'
import { SpinnerButton } from './spinner-button'

import styles from './spinner-bar.module.css'

export function SpinnerBar({ className, nextProps, prevProps }) {
    return (
        <div className={cx(styles['spinner-bar'], className)}>
            {prevProps ? <SpinnerButton direction={DIRECTIONS.left} {...prevProps} /> : null}
            {nextProps ? <SpinnerButton direction={DIRECTIONS.right} {...nextProps} /> : null}
        </div>
    )
}

SpinnerBar.propTypes = propTypes
